<template>
  <div class="ui-marker" :class="[`ui-marker__${theme}`]">
    {{ props.value }}
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'ui-marker',
});
</script>

<script setup>
import { THEME } from './constants';

const props = defineProps({
  value: {
    type: [String, Number],
    required: true,
  },
  theme: {
    type: String,
    default: THEME.DEFAULT,
  },
});

const theme = computed(() => (props.theme in THEME ? props.theme.toLowerCase() : THEME.DEFAULT.toLowerCase()));
</script>

<style lang="scss">
.ui-marker {
  --text-size: 10px;
  border-radius: 0 4px 4px 0;
  padding: 2px 4px;
  font-weight: 600;
  font-size: var(--text-size);
  line-height: 16px;

  @include breakpoint("tablet") {
    --text-size: 12px;
  }

  &__red {
    color: $white;
    background: $red;
  }
}
</style>
